import { render, staticRenderFns } from "./comp_Footer-BusinessInfo.vue?vue&type=template&id=f6a72d0a&scoped=true"
import script from "./comp_Footer-BusinessInfo.vue?vue&type=script&lang=js"
export * from "./comp_Footer-BusinessInfo.vue?vue&type=script&lang=js"
import style0 from "./comp_Footer-BusinessInfo.vue?vue&type=style&index=0&id=f6a72d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a72d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
